import axios from 'axios';
import qs from 'qs';
import { showDialog, showNotify,showLoadingToast,closeToast } from 'vant';
// import { useRouter } from 'vue-router';
import api from "../interface/index";
import { resolveApiMessage } from './apiMessage';

// 初始化 Vant
// const router = useRouter();  // 使用 Vue 3 的 router hook

let loadingCount = 0;

export const showLoading = () => {
  if (loadingCount <= 0) {
    showLoadingToast({
      duration: 20000,
    });
  }
  loadingCount++;
};

export const hideLoading = () => {
  loadingCount--;
  if (loadingCount <= 0) {
    closeToast();
    loadingCount = 0;
  }
};

export default async (url, data, opt, isLoad = false) => {
  // let lang = localStorage.getItem("lang") || "en_us";

  if (isLoad) {
    showLoading();
  }

  url = api.commonUrl + "/api" + url;
  const silentBusinessError = Boolean(opt && opt.silentBusinessError);
  const set = {
    method: 'post',
    ...opt
  };
  delete set.silentBusinessError;
  var token = localStorage.getItem('token');
  var language = localStorage.getItem("lang")|| "en_us";
  var chainId = localStorage.getItem("cur_chainId")|| "56";
  var syscoin = localStorage.getItem("sys_coin") || "usdt";
  const payload = {
    token,
    syscoin,
    chainId,
    language,
    ...data
  };
  return (set.method === 'post' ? axios.post(url, payload, set) : axios.get(url + '?' + qs.stringify({
    token
  }), { ...set, params: { ...data, token, syscoin, chainId, language } })).then(r => {

    if (isLoad) {
      hideLoading();
    }

    if (r.status === 200 && r.data.code) {
      return r.data;
    }

    if (r.data.code === 0) {
      return r.data;
    }

    throw {
      msg: 'Network error, please try again later or switch networks!'
    };

  }).then(r => {

      if (r.code === 1) {
        return r
      } else {
        if (r.code === 0) {
          if (silentBusinessError) {
            throw r;
          }
          throw {
            msg: r.info
          }
      }
      if (!r.code) {
        throw {
          msg: 'Network error, please try again later or switch networks!'
        }
      }
      // if (r.code === 406) {
      //   router.push('/setpaypwd');
      // }

      if (r.code === 405) {
        // const current = {
        //   ...router.currentRoute
        // };
        // router.push('/authEmail?redirect=' + current.path + "?id=" + current.query.id + "&money=" + current.query.money);
      }

      // if (r.code === 410) {
      //   router.push('/setpaypwd');
      // }

      if (r.code === 403 || r.code === 401) {
		// Authentication failures must not log the wallet out implicitly.
		// Token and remembered wallet session are cleared only by the explicit
		// application logout action or AppKit's DISCONNECT_SUCCESS event.
		// router.push('/user');
		showNotify({ type: 'warning', message: resolveApiMessage(r.info, language, 'Network error, please try again later or switch networks!') });
		// localStorage.removeItem('userAddress');
		return '';
        // if (r.code === 401) {
        //   localStorage.setItem('reset_time', 0);
        // }
		// router.replace('/login');
		// console.log(router);
        // const current = {
        //   ...router.currentRoute
        // };
        // if (current && current.path !== '/' && !(['/', '/reg', '/forgetpwd'].includes(current.path))) {
        //   if (current.path !== '/login') {
        //     router.replace('/login?redirect=' + current.path)
        //   }
        // }
      }
    }

    throw r;

  }).catch(r => {

    if (isLoad) {
      hideLoading();
    }
    var message = 'Network error, please try again later or switch networks!';

    if (r.info || r.msg) {
      message = resolveApiMessage(r.info || r.msg, language, message);
    }
    if (isLoad && (r.info || r.msg) && !silentBusinessError) {
      showDialog({
        message: message,
        confirmButtonText: 'Confirm'
      });
    }
    if (silentBusinessError) {
      return r;
    }
    // 使用 showNotify 来显示消息
    showNotify({ type: 'warning', message: message });
    // throw '';
	return r;
  });
}
